import { Navigate, useParams } from 'react-router-dom';

import { LoadingState } from '../../components/loading-state';
import { useGetAppointmentDetailsQuery } from '../../store/api';
import { resourceDetailPath } from '../../utils/resource-routes';

/**
 * Forwards the pre-consolidation appointment URLs to the canonical one
 * (GDN-2723). See encounter-redirect for why these shims exist.
 */
export default function AppointmentRedirect() {
  const { appointmentId: scoped, id: legacy } = useParams<{
    appointmentId?: string;
    id?: string;
  }>();
  const appointmentId = scoped || legacy || '';

  const { data, isLoading } = useGetAppointmentDetailsQuery(
    { appointmentId },
    { skip: !appointmentId },
  );

  if (!appointmentId) return <Navigate to="/admin-v2" replace />;
  if (isLoading) return <LoadingState message="Opening appointment..." />;

  const organizationId = data?.appointment?.organization_id;
  if (!organizationId) return <Navigate to="/admin-v2" replace />;

  return (
    <Navigate
      to={resourceDetailPath({ organizationId }, 'appointment', appointmentId)}
      replace
    />
  );
}
